import { useState } from 'react'

export function useTimelimitedFlag(ms: number): [flag: boolean, on: () => void, off: () => void] {
  const [flag, setFlag] = useState(false)
  const [timer, setTimer] = useState<NodeJS.Timeout>()

  function on() {
    if (timer !== undefined) {
      off()
    }
    setTimer(setTimeout(off, ms))
    setFlag(true)
  }

  function off() {
    setFlag(false)
    if (timer !== undefined) {
      clearTimeout(timer)
      setTimer(undefined)
    }
  }

  return [flag, on, off]
}
